import React from 'react';
import classNames from 'classnames';
import QualificationQuestion from '../QualificationQuestion';
import { QualificationQuestionType } from 'models/DealRoom';
import { FieldArray } from 'react-final-form-arrays';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import useReordering from '../../hooks/useReordering';

import './PreviewQualificationQuestions.styles.scss';
import './PreviewQualificationQuestions.styles.responsive.scss';

type PreviewQualificationQuestionsProps = {
  className?: string;
};

const PreviewQualificationQuestions: React.FC<
  PreviewQualificationQuestionsProps
> = (props) => {
  const { className } = props;

  const { isReordering, setIsReordering, onDragEnd } = useReordering();

  const classes = classNames('preview-qualification-questions', className);

  return (
    <div className={classes}>
      <FieldArray<QualificationQuestionType> name="qualificationQuestions">
        {({ fields }) => {
          const answersIds = fields.value.map(({ id }) => id);

          return (
            <DndContext
              collisionDetection={closestCenter}
              onDragEnd={(e) => onDragEnd(e, fields.value, fields.move)}
            >
              <SortableContext
                items={answersIds}
                strategy={verticalListSortingStrategy}
              >
                {fields.map((_, index) => {
                  const id = fields.value[index].id;

                  return (
                    <QualificationQuestion
                      key={id}
                      id={id}
                      question={fields.value[index]}
                      isReordering={isReordering}
                      setIsReordering={setIsReordering}
                    />
                  );
                })}
              </SortableContext>
            </DndContext>
          );
        }}
      </FieldArray>
    </div>
  );
};

export default PreviewQualificationQuestions;
